module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921125649_T.8760d50b.jpg";